"use client";

import React, { useState } from "react";
import Sidebar from "../common/Sidebar";
import Header from "../common/Header";
import MetaApiForm from "../messages/MetaApiForm";
import { Send, Clock3 } from "lucide-react";
import { ScheduleList } from "../messages/ScheduledList";
import PageWrapper from "../../../components/admin/common/PageWrapper";

const TABS = [
  {
    key: "send",
    label: "Send Message",
    icon: <Send className="w-4 h-4 mr-1 text-blue-600" />,
  },
  {
    key: "messages",
    label: "Scheduled Messages",
    icon: <Clock3 className="w-4 h-4 mr-1 text-emerald-600" />,
  },
];

const SendScheduleManager = ({
  activeTab,
  onTabChange,
  templates,
  groups,
  messages,
  refreshSchedule,
  hasMore,
  onPaginate,
  totalCount,
  historyStacks,
}) => {
  const [viewTab, setViewTab] = useState("send");

  return (
    <div className="flex h-screen bg-white gap-4 p-4">
      <div className="flex-shrink-0">
        <div className="h-full">
          <Sidebar />
        </div>
      </div>

      <div className="flex-1 flex-shrink-0 h-full bg-[#F3EFFF] rounded-[27px] overflow-y-auto">
        <PageWrapper>
          <div className="p-6 space-y-6">
            <div>
              <Header
                title={"Send / Schedule message"}
                desc="Here you can send message now or later"
              />
            </div>

            <div className="mt-6 w-full">
              <div className="flex w-[475px] space-x-4 border-b-2 border-gray-200">
                {TABS.map((tab) => {
                  const isActive = viewTab === tab.key;
                  return (
                    <button
                      key={tab.key}
                      onClick={() => setViewTab(tab.key)}
                      className={`relative cursor-pointer flex items-center px-4 py-2 text-base font-medium transition-colors duration-200 ${
                        isActive ? "text-[#4F22D8]" : "text-black"
                      }`}
                    >
                      {tab.icon}
                      {tab.label}
                      {isActive && (
                        <span className="absolute -bottom-[2px] left-0 right-0 h-0.5 bg-blue rounded-full" />
                      )}
                    </button>
                  );
                })}
              </div>

              {/* Show message status tabs only when schedule tab is active */}
              {viewTab === "messages" && (
                <div className="mt-4 flex space-x-4">
                  {["pending", "sent", "failed"].map((status) => (
                    <button
                      key={status}
                      onClick={() => onTabChange(status)}
                      className={`px-4 py-2 rounded-full text-sm font-medium ${
                        activeTab === status
                          ? "bg-blue-600 text-white"
                          : "bg-gray-100 text-gray-700"
                      }`}
                    >
                      {status.charAt(0).toUpperCase() + status.slice(1)}
                    </button>
                  ))}
                </div>
              )}
            </div>

            <div className="flex-1 overflow-y-auto">
              <div className="">
                {viewTab === "send" && (
                  <MetaApiForm
                    templates={templates}
                    groups={groups}
                    refreshSchedule={refreshSchedule}
                  />
                )}

                {viewTab === "messages" && (
                  <ScheduleList
                    status={activeTab}
                    messages={messages[activeTab]}
                    hasMore={hasMore[activeTab]}
                    totalCount={totalCount[activeTab]}
                    onPaginate={(direction) => onPaginate(activeTab, direction)}
                    historyStacks={historyStacks[activeTab]}
                  />
                )}
              </div>
            </div>
          </div>
        </PageWrapper>
      </div>
    </div>
  );
};

export default SendScheduleManager;
